import { render, staticRenderFns } from "./BaseButtonPill.vue?vue&type=template&id=2586a3f4&scoped=true&"
import script from "./BaseButtonPill.vue?vue&type=script&lang=js&"
export * from "./BaseButtonPill.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonPill.vue?vue&type=style&index=0&id=2586a3f4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2586a3f4",
  null
  
)

export default component.exports